var locale = {
    placeholder: 'Select time'
};
export default locale;


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/node_modules/_antd@3.0.0-beta.7@antd/es/time-picker/locale/en_US.js
// module id = 110
// module chunks = 0